import { connect } from 'react-redux';

import { closeCookieSettings } from '../../actions/CookieSettings';

import CookieSettings from '../../components/CookieSettings/CookieSettings';

const mapStateToProps = (state) => ({
    isOpened: state.cookieSettings.isOpened,
})


const mapDispatchToProps = (dispatch) => ({
    onCloseSettings: () => {
        dispatch(closeCookieSettings())
    },

    onSaveSettings: () => {
        dispatch(closeCookieSettings())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(CookieSettings)
